'use strict';Object.defineProperty(exports,'__esModule',{value:true});exports.getVersionString = getVersionString;var VERSION='2.9.2';function getVersionString(){return VERSION;}
//# sourceMappingURL=Version.js.map



//////////////////
// WEBPACK FOOTER
// ./~/dashjs/build/es5/src/core/Version.js
// module id = 403
// module chunks = 1